// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M20,12.5H4v-1h16V12.5z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-minus-om5K6FiB.js.map
